class ComponentCartQuantity {
  constructor(container) {
    this.container = container;
    this.init();
  }

  init() {
    this.handleQuantityChange();
  }

  handleQuantityChange() {
    const qtyInput = this.container.querySelector(".component-cart-qty");
    const increaseButton = this.container.querySelector(".component-cart-plus");
    const decreaseButton = this.container.querySelector(".component-cart-minus");
    const cartForm = this.container.closest("form.cart-items"); 

    increaseButton.addEventListener("click", () => {
      let currentQty = parseInt(qtyInput.value, 10);
      qtyInput.value = currentQty + 1;
      this.submitForm(cartForm);
    });

    decreaseButton.addEventListener("click", () => {
      let currentQty = parseInt(qtyInput.value, 10);
      if (currentQty > 1) {
        qtyInput.value = currentQty - 1;
        this.submitForm(cartForm); 
      }
    });

    qtyInput.addEventListener("input", () => {
      if (parseInt(qtyInput.value, 10) < 1) {
        qtyInput.value = 1;
      }
      this.submitForm(cartForm);
    });
  }

  submitForm(form) {
    if (form) {
      form.submit();
    }
  }

}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".js-qty-wrap").forEach(container => {
    new ComponentCartQuantity(container);
  });
});
